import React, { useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const REFERRING_DENTIST_STORAGE_KEY = 'referringDentistData';

const ReferringDentistSection = ({ data, errors, onChange }) => {
  // Load saved data on mount
  useEffect(() => {
    try {
      const savedData = localStorage.getItem(REFERRING_DENTIST_STORAGE_KEY);
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        // Only restore if current data is empty
        const isEmpty = !data?.fullName && 
                       !data?.practiceName && 
                       !data?.email && 
                       !data?.phone;
        
        if (isEmpty && parsedData) {
          Object.keys(parsedData)?.forEach(field => {
            if (parsedData?.[field]) {
              onChange('referringDentist', field, parsedData?.[field]);
            }
          });
        }
      }
    } catch (error) {
      console.error('Error loading referring dentist data:', error);
    }
  }, []); // Empty dependency array - only run once on mount

  // Auto-save to localStorage whenever data changes
  useEffect(() => {
    if (data && (data?.fullName || data?.practiceName || data?.email || data?.phone)) {
      try {
        localStorage.setItem(REFERRING_DENTIST_STORAGE_KEY, JSON.stringify(data));
      } catch (error) {
        console.error('Error saving referring dentist data:', error);
      }
    }
  }, [data]);

  const handleChange = (field) => (e) => {
    onChange('referringDentist', field, e?.target?.value);
  };

  const handleClearSavedData = () => {
    try {
      localStorage.removeItem(REFERRING_DENTIST_STORAGE_KEY);
      // Clear form fields
      onChange('referringDentist', 'fullName', '');
      onChange('referringDentist', 'practiceName', '');
      onChange('referringDentist', 'email', '');
      onChange('referringDentist', 'phone', '');
    } catch (error) {
      console.error('Error clearing referring dentist data:', error);
    }
  };

  const hasSavedData = data?.fullName || 
                       data?.practiceName || 
                       data?.email || 
                       data?.phone;

  return (
    <div className="glass-card rounded-2xl p-6 hover-glow hover-lift">
      <div className="mb-5 flex items-start justify-between">
        <div>
          <h2 className="text-lg font-semibold text-white mb-1">
            Confrère adresseur
          </h2>
          <p className="text-sm text-gray-400">
            Vos coordonnées professionnelles
          </p>
        </div>
        {hasSavedData && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClearSavedData}
            iconName="Trash2"
            className="text-gray-400 hover:text-red-400"
          >
            Effacer
          </Button>
        )}
      </div>
      
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Nom du Praticien"
            type="text"
            placeholder="Dr Jean Dupont"
            value={data?.fullName}
            onChange={handleChange('fullName')}
            error={errors?.fullName}
            required
          />

          <Input
            label="Cabinet"
            type="text"
            placeholder="Cabinet Dentaire"
            value={data?.practiceName}
            onChange={handleChange('practiceName')}
            error={errors?.practiceName}
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Email"
            type="email"
            placeholder="dr.dupont@exemple.fr"
            value={data?.email}
            onChange={handleChange('email')}
            error={errors?.email}
            required
          />

          <Input
            label="Téléphone"
            type="tel"
            placeholder="03 81 XX XX XX"
            value={data?.phone}
            onChange={handleChange('phone')}
            error={errors?.phone}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default ReferringDentistSection;